const DROPDOWN_CONTENT_DEFAULT_SIDE_OFFSET = 4;
const DROPDOWN_CONTENT_DEFAULT_COLLISION_PADDING = 10;

export { DROPDOWN_CONTENT_DEFAULT_COLLISION_PADDING, DROPDOWN_CONTENT_DEFAULT_SIDE_OFFSET };
//# sourceMappingURL=style.mjs.map
